module.exports = __webpack_public_path__ + "components/home-header/static/header-5--huge-0fc136322d47f369b29259bc362c6545.jpg";